import React from "react";
import PropTypes from "prop-types";
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { getDurationString } from "../../utils/datetime";

const TrainingHoursCell = ({ duration, ...other }) => {
  const { t } = useTranslation();
  return (
    <Typography {...other} noWrap>
      {getDurationString(duration, t)}
    </Typography>
  );
};

export default TrainingHoursCell;

TrainingHoursCell.propTypes = {
  duration: PropTypes.number
};
